import React from "react";

import { ResponsiveLine } from "@nivo/line";
import LineChartTooltip from "../tool-tip/LineChartToolTip";

const LineChart = ({ data, width, height, tiny, responsive, onPointClick }) => {
  const tinyChartConfig = {
    enableArea: false,
    axisLeft: null,
    axisBottom: null,
    axisTop: null,
    axisRight: null,
    legends: [],
    enablePoints: false,
    margin: { top: 25, right: 15, bottom: 25, left: 15 },
  };

  const allValues = (data ?? []).flatMap((series) =>
    series.data.map((d) => d.y),
  );
  const maxDataValue = allValues.length ? Math.max(...allValues) : 0;
  const yMax = maxDataValue > 0 ? Math.ceil(maxDataValue * 1.15) : "auto";

  return (
    <div style={responsive ? { display: "contents" } : { width, height }}>
      <ResponsiveLine
        data={data}
        tooltip={LineChartTooltip}
        margin={{ top: 25, right: 15, bottom: 50, left: 40 }}
        xScale={{ type: "point" }}
        yScale={{
          type: "linear",
          min: "auto",
          max: yMax,
          stacked: false,
          reverse: false,
        }}
        colors={{ datum: "color" }}
        enableGridX={false}
        enableGridY={false}
        curve="natural"
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 15,
          tickRotation: 0,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 15,
          tickRotation: 0,
          tickValues: 4,
        }}
        pointSize={8}
        pointColor={"#fff"}
        pointBorderWidth={2}
        pointBorderColor={(point) => {
          //console.log(point); // inspect available keys once, then remove
          return point.seriesColor ?? point.color ?? "#000";
        }}
        pointLabelYOffset={-12}
        onClick={onPointClick}
        enableArea={true}
        useMesh={true}
        defs={[
          {
            colors: [
              { color: "inherit", offset: 0 },
              { color: "inherit", offset: 100, opacity: 0 },
            ],
            id: "gradientA",
            type: "linearGradient",
          },
        ]}
        fill={[{ id: "gradientA", match: "*" }]}
        theme={{
          legends: {
            text: {
              fontSize: 12,
              fill: "#111111",
              outlineWidth: 0,
              outlineColor: "transparent",
              fontWeight: 500,
            },
          },
        }}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: -50,
            translateY: 55,
            itemsSpacing: 70,
            itemDirection: "left-to-right",
            itemOpacity: 1,
            itemWidth: 80,
            itemHeight: 20,
            symbolSize: 12,
            symbolShape: "square",
            symbolBorderColor: "rgba(0, 0, 0, .5)",
            effects: [
              {
                on: "hover",
                style: { itemBackground: "rgba(0, 0, 0, .03)", itemOpacity: 1 },
              },
            ],
          },
        ]}
        animate={true}
        {...(tiny ? tinyChartConfig : {})}
      />
    </div>
  );
};

export default LineChart;

// if we want all props as js object
// const LineChartProps = {
//   data,
//   margin: { top: 10, right: 15, bottom: 50, left: 40 },
//   xScale: { type: "point" },
//   yScale: {
//     type: "linear",
//     min: "auto",
//     max: "auto",
//     stacked: true,
//     reverse: false,
//   },
//   colors: { datum: "color" },
//   enableGridX: false,
//   enableGridY: false,
//   curve: "natural",
//   axisTop: null,
//   axisRight: null,
//   axisBottom: {
//     tickSize: 0,
//     tickPadding: 15,
//     tickRotation: 0,
//   },
//   axisLeft: {
//     tickSize: 0,
//     tickPadding: 15,
//     tickRotation: 0,
//     tickValues: 4,
//   },
//   pointSize: 8,
//   pointColor: "#fff",
//   pointBorderWidth: 2,
//   pointBorderColor: { from: "serieColor" },
//   pointLabelYOffset: -12,
//   enableArea: true,
//   useMesh: true,
//   defs: [
//     {
//       colors: [
//         {
//           color: "inherit",
//           offset: 0,
//         },
//         {
//           color: "inherit",
//           offset: 100,
//           opacity: 0,
//         },
//       ],
//       id: "gradientA",
//       type: "linearGradient",
//     },
//   ],
//   // enableSlices:"x",
//   fill: [
//     {
//       id: "gradientA",
//       match: "*",
//     },
//   ],
//   theme: {
//     legends: {
//       text: {
//         fontSize: 12,
//         fill: "#111111",
//         outlineWidth: 0,
//         outlineColor: "transparent",
//         fontWeight: 500,
//       },
//     },
//   },
//   legends: [
//     {
//       anchor: "bottom",
//       direction: "row",
//       justify: false,
//       translateX: -50,
//       translateY: 55,
//       itemsSpacing: 70,
//       itemDirection: "left-to-right",
//       itemOpacity: 1,
//       itemWidth: 80,
//       itemHeight: 20,
//       symbolSize: 12,
//       symbolShape: "square",
//       symbolBorderColor: "rgba(0, 0, 0, .5)",
//       effects: [
//         {
//           on: "hover",
//           style: {
//             itemBackground: "rgba(0, 0, 0, .03)",
//             itemOpacity: 1,
//           },
//         },
//       ],
//     },
//   ],
//   animate: true,
//   ...(tiny ? tinyChartConfig : {}),
// }
